import type { WahaSessionHealth } from '../../types/wahaHealth';

type Props = {
  health?: WahaSessionHealth | null;
  compact?: boolean;
  className?: string;
};

function releaseLabel(value?: string | null) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function WahaHealthAlert({ health, compact = false, className = '' }: Props) {
  if (!health?.hasIssue) return null;
  const isError = health.severity === 'error';
  const release = releaseLabel(health.endsAt);
  const colors = isError
    ? 'border-red-300 bg-red-50 text-red-800'
    : 'border-amber-300 bg-amber-50 text-amber-900';

  if (compact) {
    return (
      <span
        title={`${health.title}${health.message ? ` — ${health.message}` : ''}${release ? ` Liberação prevista: ${release}` : ''}`}
        className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-semibold ${colors} ${className}`}
      >
        <span aria-hidden="true">{isError ? '●' : '⚠'}</span>
        {health.code === 'REACHOUT_TIMELOCK' ? 'Envios limitados' : 'Problema'}
      </span>
    );
  }

  return (
    <div className={`rounded-lg border px-3 py-2 text-sm ${colors} ${className}`} role="status">
      <div className="flex items-start gap-2">
        <span className="mt-0.5 shrink-0" aria-hidden="true">{isError ? '●' : '⚠️'}</span>
        <div className="min-w-0">
          <p className="font-semibold">{health.title}</p>
          {health.message && <p className="mt-0.5 text-xs leading-5 opacity-90">{health.message}</p>}
          {release && <p className="mt-1 text-xs font-medium">Liberação prevista: {release}</p>}
          {health.enforcementType && (
            <p className="mt-1 text-[11px] opacity-75">Código informado pelo WhatsApp: {health.enforcementType}</p>
          )}
          {health.code === 'REACHOUT_TIMELOCK' && (
            <p className="mt-1 text-xs">Não reinicie nem leia o QR novamente: a limitação é do WhatsApp e termina automaticamente.</p>
          )}
        </div>
      </div>
    </div>
  );
}
